var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-sm",style:(("\n        justify-content: " + _vm.justifyContent + ";\n        width: 100%; \n        margin-left: 0;\n    "))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }